import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const receptionSelector = (state: State) => state.reception.reception;
export const receptionOrderSelector = (state: State) => state.reception.receptionOrder;
export const totalSelector = (state: State) => state.reception.total;
export const noMoreSelector = (state: State) => state.reception.noMore;
export const pageSelector = (state: State) => state.reception.page;
export const errorCodeSelector = (state: State) => state.reception.errorCode;

const receptionsIdsSelector = (state: State) => state.reception.receptions.ids;
const receptionsEntitiesSelector = (state: State) =>
  state.reception.receptions.entities;
export const receptionsSelector = createSelector(
  [receptionsIdsSelector, receptionsEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const receptionOrdersIdsSelector = (state: State) => state.reception.receptionOrders.ids;
const receptionOrdersEntitiesSelector = (state: State) =>
  state.reception.receptionOrders.entities;
export const receptionOrdersSelector = createSelector(
  [receptionOrdersIdsSelector, receptionOrdersEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);

const receptionContainersIdsSelector = (state: State) => state.reception.receptionContainers.ids;
const receptionContainersEntitiesSelector = (state: State) =>
  state.reception.receptionContainers.entities;
export const receptionContainersSelector = createSelector(
  [receptionContainersIdsSelector, receptionContainersEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);